import React from "react";
import { useDispatch } from "react-redux";
import { updateServiceRequest } from "../../redux/action";

function WaiterCard({ res, status }) {
    const dispatch = useDispatch();

    const handleServe = (requestId) => {
        const dto = { requestId: requestId, statusId: 1 };
        dispatch(updateServiceRequest(dto));
    };

    const handleCancel = (requestId) => {
        const dto = { requestId: requestId, statusId: 2 };
        dispatch(updateServiceRequest(dto));
    };

    return (
        <li className="reservation-card">
            <div className="card-header">     
                 <p> T-{res.restaurantTable?.tableName}</p>         
                <span className={`status ${status.toLowerCase()}`}>
                    {status}
                </span>
            </div>
            
            <div className="card-content">
                <div className="card-body">
                   
                    <div className="row">                       
                        <p><strong>⏰</strong> {res.requestTime}</p>
                    </div>
                    <div className="row">                       
                        <p><strong>📝 {res.notes}</strong></p>
                    </div>
                </div>
                
                {/* Fixed the logic block with curly braces and proper ternary */}
                {status === 'Pending' ? (
                    <div>
                        <button className="serve-btn" onClick={() => handleServe(res.requestId)}>
                            ✔️ Serve
                        </button>
                        <button className="cancel-btn" onClick={() => handleCancel(res.requestId)}>
                            ✖ Cancel
                        </button>
                    </div>
                ) : null}
            </div>
        </li>
    );
}

export default WaiterCard;